export enum SharedAssetRequestStatus {
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  REVOKED = 'REVOKED',
  DELETED = 'DELETED'
}

export interface AvailableK8sCluster {
  assetId: string
  clusterName: string
  owningTeamId: string
  availableNamespaces: string[]
  currentlySharedNamespaces: string[]
}

export interface K8sAssetToRequestMap {
  [k: string]: { currentStatus: SharedAssetRequestStatus; namespace: string }[]
}
export interface K8sIdToTeamMapping {
  [k: string]: { identifier: string; name: string }
}

export interface K8sAssetRequests {
  assetToRequestMap: K8sAssetToRequestMap
  idToTeamMapping: K8sIdToTeamMapping
}
